import { BsCameraVideoOffFill } from 'react-icons/bs';
import { MdMicOff } from 'react-icons/md';
import ParentModal from './ParentModal';

const SessionPermissionModal = () => {
  // rendering session permission modal component here
  return (
    <ParentModal onClick={() => {}} hideCloseButton>
      <div className='flex items-center justify-center gap-5'>
        <BsCameraVideoOffFill className='size-20 text-base-red' />
        <MdMicOff className='size-20 text-base-red' />
      </div>

      <div className='text-center mt-3 space-y-2'>
        <h2 className='text-legal-dark-blue font-semibold text-2xl'>
          Allow Camera & Microphone
        </h2>

        <p className='text-sm'>
          To join the session, allow access to your camera and microphone{' '}
          <span className='text-base-light-blue font-medium'>
            (at least the microphone)
          </span>
          . You can mute either at any time during the session.
        </p>
      </div>
    </ParentModal>
  );
};

export default SessionPermissionModal;
